import { withInstall } from "../../utils/vue/install.mjs";
import { iconProps } from "./src/icon.mjs";
import icon_default from "./src/icon2.mjs";

//#region ../../packages/components/icon/index.ts
const ElIcon = withInstall(icon_default);

//#endregion
export { ElIcon, ElIcon as default, iconProps };
//# sourceMappingURL=index.mjs.map